import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials } from '@/mocks/testimonials';

const faqItems = [
  {
    question: '如何购买黄油小熊正版周边产品？',
    answer: '您可以通过官方网站商城、官方微信小程序以及授权线下门店购买正版黄油小熊周边。购买时请认准官方防伪标识，扫描产品吊牌上的二维码可验证真伪。',
  },
  {
    question: '黄油小熊毛绒玩偶如何清洗保养？',
    answer: '建议手洗：使用30度以下温水和中性洗涤剂，轻轻揉搓后清水漂净，用干毛巾吸去多余水分，放在阴凉通风处自然晾干。请勿使用洗衣机、烘干机或暴晒，以免变形脱色。',
  },
  {
    question: '新品发布在哪里可以第一时间获取信息？',
    answer: '关注黄油小熊官方微信公众号、微博和小红书账号，订阅官方网站通讯录，即可第一时间获取新品发布、限量发售和独家活动资讯。',
  },
  {
    question: '黄油小熊盲盒系列包含哪些款式？',
    answer: '首套盲盒「四季物语」包含6款常规款和1款隐藏款。常规款以春夏秋冬为主题设计，隐藏款为「星月夜」特殊版本。每盒随机包含一款，收集全套可获得独特的展示效果。',
  },
  {
    question: '海外用户如何购买黄油小熊周边？',
    answer: '目前海外用户可通过官方网站商城下单，我们支持部分国家和地区的国际配送。具体配送范围和费用请在结算页面查看。如有特殊需求，欢迎联系客服咨询。',
  },
  {
    question: '如何成为黄油小熊的授权经销商？',
    answer: '感谢您对黄油小熊品牌的认可。经销商合作请通过官网联系页面提交合作意向，我们的商务团队会在5个工作日内与您联系，详细沟通合作细节和授权条件。',
  },
];

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黄油小熊',
    description: '了解黄油小熊品牌故事、品牌理念、用户口碑及联系方式。黄油小熊是当下最受欢迎的治愈系IP形象之一。',
    url: 'https://butterbear.com/about',
    mainEntity: {
      '@type': 'Organization',
      name: '黄油小熊',
      description: '黄油小熊是当下最受欢迎的治愈系IP形象之一，集萌系外观与暖心设计于一体。',
      foundingDate: '2019',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'hello@butterbear.com',
      },
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <main className="pt-20 pb-14 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          {/* Brand Story */}
          <section className="mb-14 md:mb-20">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                关于黄油小熊
              </h1>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                一只诞生于温暖午后的小熊，用最柔软的方式，治愈每一颗疲惫的心。
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto items-center">
              <div className="aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cute%20warm%20yellow%20butter%20bear%20sitting%20in%20a%20cozy%20creative%20studio%20with%20sketchbooks%20and%20design%20tools%20scattered%20around%2C%20warm%20natural%20lighting%2C%20artistic%20atmosphere%2C%20cream%20and%20golden%20tones%2C%20kawaii%20illustration%20style%2C%20storytelling%20editorial%20photography&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="黄油小熊品牌故事"
                  title="黄油小熊 - 品牌故事"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                  品牌故事
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  2019年的一个温暖午后，设计师小林在素描本上勾勒出一个圆滚滚的小熊轮廓。那个小熊有着柔软的线条、温暖的眼神，还有一身像融化黄油般温柔的颜色——「黄油小熊」由此诞生。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  从最初的插画分享，到第一款毛绒玩偶的诞生，再到如今拥有超过500万粉丝的超级IP，黄油小熊始终不忘「用温暖治愈每一个日常」的初心。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  每一个产品、每一次联名，都承载着我们对「治愈」的理解。我们希望黄油小熊不仅是一个可爱的形象，更是你生活中的温暖伙伴。
                </p>
              </div>
            </div>
          </section>

          {/* Brand Values */}
          <section className="mb-14 md:mb-20 bg-background-100 rounded-2xl py-12 md:py-16 px-4 md:px-10">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
                品牌理念
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    icon: 'ri-heart-3-line',
                    title: '治愈温暖',
                    desc: '每一款产品都以「治愈」为设计出发点，用软萌的触感和温暖的色彩，为你的生活增添一份柔软与美好。',
                  },
                  {
                    icon: 'ri-shield-star-line',
                    title: '品质至上',
                    desc: '从面料选择到生产工艺，每一个环节都严格把控。我们坚持使用安全环保的材料，让你用得安心、用得舒心。',
                  },
                  {
                    icon: 'ri-lightbulb-flash-line',
                    title: '创意无限',
                    desc: '不断探索新的设计可能，通过联名合作和季节限定，为粉丝带来持续的惊喜与新鲜感。',
                  },
                ].map((item) => (
                  <div key={item.title} className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-50 flex items-center justify-center">
                      <i className={`${item.icon} text-2xl text-primary-500`}></i>
                    </div>
                    <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="mb-14 md:mb-20">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
                粉丝口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {testimonials.map((t) => (
                  <div
                    key={t.id}
                    className="bg-background-50 rounded-xl p-5 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                        loading="lazy"
                      />
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.date}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-2">{t.content}</p>
                    <p className="text-xs text-foreground-400">购买：{t.product}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-14 md:mb-20">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqItems.map((item, index) => (
                  <details
                    key={index}
                    className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between p-5 cursor-pointer">
                      <h4 className="text-sm font-medium text-foreground-900 pr-4">{item.question}</h4>
                      <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '商务合作',
                  content: 'hello@butterbear.com',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '客服支持',
                  content: 'support@butterbear.com',
                },
                {
                  icon: 'ri-map-pin-line',
                  title: '公司地址',
                  content: '上海市静安区南京西路1688号',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-background-100 rounded-xl p-5 text-center"
                >
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-background-50 flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h4>
                  <p className="text-xs text-foreground-500">{item.content}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}